import { useCallback, useMemo } from "react"
import { useParams } from "react-router-dom"
import { useApplicationPermissions } from "../../../../../hooks/useApplicationPermissions"
import { useDeleteConfirm } from "../../../../../hooks/useDeleteConfirm"
import { ApplicationPermissionGet } from "../../../../models/ApplicationPermission"
import { DimaFeatureShortNameEnum } from "../../../../models/Authorization"
import { deleteEntity } from "../../../../utils/deleteEntity"
import { booleanComparator, getDoneIcon, getEmptyIcon } from "../../../../utils/getBooleanFlagIcon"
import { DiMaAddButton } from "../../../partials/DiMaAddButton"
import { EntityRow, EntityTab } from "../../../partials/EntityTab"

export function ApplicationPermissions() {
  const { applicationId } = useParams()
  const { requestDelete, DeleteConfirmDialog } = useDeleteConfirm()

  const { applicationPermissions, isLoadingApplicationPermissions } =
    useApplicationPermissions(applicationId)

  const permissionsColumns = [
    {
      field: "name",
      headerName: "Name",
      isLink: true,
      linkBasePath: `/applications/${applicationId}/permissions`,
    },
    {
      field: "noDevice",
      headerName: "No Device",
      renderCell: (row: EntityRow) => row.noDevice ? getDoneIcon() : getEmptyIcon(),
      sortComparator: booleanComparator,
    },
    { field: "description", headerName: "Description" },
  ]

  const sorted = [...applicationPermissions].sort(
    (a: ApplicationPermissionGet, b: ApplicationPermissionGet) =>
      (a.name ?? "").localeCompare(b.name ?? "")
  )

  const permissionsRows = sorted.map((p: ApplicationPermissionGet) => ({
    id: p.id,
    name: p.name,
    description: p.description,
    noDevice: p.noDevice,
  }))

  const toolbar = useMemo(
    () => (
      <DiMaAddButton
        url={`/applications/${applicationId}/permissions/create`}
        feature={DimaFeatureShortNameEnum.AM}
      />
    ),
    [applicationId]
  )

  const handleActionMenuClick = useCallback((item: { title: string }, row: EntityRow) => {
      if (item.title === "Delete") {
        requestDelete(() =>
          deleteEntity(
            `/applications/${applicationId}/permissions/${row.id}`
          )
        )
      }
    }, [applicationId, requestDelete])

  return (
    <>
      {DeleteConfirmDialog}
      <EntityTab
        rows={permissionsRows}
        cols={permissionsColumns}
        isLoading={isLoadingApplicationPermissions}
        toolbar={toolbar}
        actionItems={[{ title: "Delete", iconName: "icon_abb_dias icon-abb_delete" }]}
        onActionMenuClick={handleActionMenuClick}
      />
    </>
  )
}
